const subLedger = {
  path: 'subLedger',
  component: resolve => require(['@/pages/admin/reviewed/alipay/subLedger'], resolve),
  meta: {isSubLedger: true}
}

export default subLedger
